export const DialogTermsAndCondition = () => import('./DialogTermsAndCondition')